import Colors from 'constants/Colors';

export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    padding: 8,
    justifyContent: 'space-around',
    alignItems: 'center',
    backgroundColor: Colors.grayBackground,
    fontSize: 12,
    fontWeight: 'bold',
    width: '100%',
    color: Colors.darkText,
  },
  guestType: {
    display: 'flex',
    fontSize: 12,
    padding: '24px 6px',
    backgroundColor: Colors.lightGray,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
  },
};
